import React, { useEffect, useRef } from 'react';
import gsap from 'gsap'
import { ReactLenis } from 'lenis/react'
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const GSAPProductReveal = () => {
    const lenisRef = useRef()

    useGSAP(() => {
        // ScrollTrigger.create({
        //     trigger: '.pinned',
        //     start: "top top",
        //     endTrigger: "whitespace",
        //     end: "bottom top",
        //     pin: true,
        //     pinSpacing: false,

        // }),

            gsap.from(".pinned", {
                scrollTrigger: {
                    trigger: '.pinned',
                    start: "top top",
                    endTrigger: "whitespace",
                    end: "bottom top",
                    pin: true,
                    pinSpacing: false,
                },
                marker: true
            });

            gsap.to('.header-row h1', {
                rotation: 0,
                duration: 2,
                ease: 'bounce.out'
            });
    })

    useEffect(() => {


        function update(time) {
            lenisRef.current?.lenis?.raf(time * 1000)
        }

        gsap.ticker.add(update)

        return () => gsap.ticker.remove(update)
    }, [])
    return (
        <>
            <ReactLenis ref={lenisRef}>
                <div className=" product-reveal">
                    <section className="product-hero">
                        <h1>
                            Shoora
                        </h1>
                    </section>
                    <section className="info">
                        <div className="header-rows">
                            <div className="header-row">
                                <h1>Motion</h1>
                            </div>
                            <div className="header-row">
                                <h1>Skills</h1>
                            </div>
                        </div>
                    </section>
                    <section className="header-info">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, necessitatibus odit eos natus atque tempore animi nobis voluptas eligendi omnis dolorem veniam qui in et. Corrupti similique illo ea placeat?</p>

                        <div className="header-images">
                            <div className="img"><img src="https://images.pexels.com/photos/17557997/pexels-photo-17557997/free-photo-of-the-dashboard-of-a-car-with-a-blue-screen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" /></div>
                            <div className="img"><img src="https://images.pexels.com/photos/17557997/pexels-photo-17557997/free-photo-of-the-dashboard-of-a-car-with-a-blue-screen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" /></div>
                            <div className="img"><img src="https://images.pexels.com/photos/24346971/pexels-photo-24346971/free-photo-of-home-monitoring-security.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" /></div>
                            <div className="img"><img src="https://images.pexels.com/photos/7541981/pexels-photo-7541981.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" /></div>
                        </div>
                    </section>

                    <section className="whitespace"></section>

                    <section className="pinned">
                        <div className="revealer">
                            <div className="revealer-1"></div>
                            <div className="revealer-2"></div>
                        </div>
                    </section>

                    <section className="website-content">
                        <h1>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellendus pariatur velit unde possimus explicabo officiis blanditiis. Nisi aliquam maiores esse praesentium recusandae, aperiam blanditiis tempore, excepturi in, commodi perferendis ipsum?
                        </h1>
                    </section>
                </div>
            </ReactLenis>

        </>
    )
}

export default GSAPProductReveal